import { render } from "./invite.vue?vue&type=template&id=146a3d3c&scoped=true"
import script from "./invite.vue?vue&type=script&lang=js"
export * from "./invite.vue?vue&type=script&lang=js"

import "./invite.vue?vue&type=style&index=0&id=146a3d3c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146a3d3c"]])

export default __exports__